var _g, _g2, _g3, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHexagonBlueMin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 508,
    height: 575,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253 40.578a1.998 1.998 0 0 1 2 0l211.98 122.45c.619.357 1 1.017 1 1.732v244.901a2 2 0 0 1-1 1.732L255 533.843a2.001 2.001 0 0 1-2 0L41.02 411.393a2 2 0 0 1-1-1.732V164.76a2 2 0 0 1 1-1.732L253 40.578z",
    stroke: "#6C84F8",
    strokeWidth: 12,
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.02 40.578a2 2 0 0 1 2.001 0L478 163.028c.619.357 1 1.017 1 1.732v244.901a2 2 0 0 1-1 1.732l-211.979 122.45a2.003 2.003 0 0 1-2.001 0L52.04 411.393a2 2 0 0 1-1-1.732V164.76a2 2 0 0 1 1-1.732l211.98-122.45z",
    stroke: "#6C84F8",
    strokeWidth: 12,
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.979 40.578a2 2 0 0 1 2.001 0l211.979 122.45c.619.357 1 1.017 1 1.732v244.901a2 2 0 0 1-1 1.732L243.98 533.843a2.003 2.003 0 0 1-2.001 0l-211.98-122.45a2 2 0 0 1-.999-1.732V164.76a2 2 0 0 1 1-1.732l211.979-122.45z",
    stroke: "#6C84F8",
    strokeWidth: 12,
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M253 40.578a1.998 1.998 0 0 1 2 0l211.98 122.45c.619.357 1 1.017 1 1.732v244.901a2 2 0 0 1-1 1.732L255 533.843a2.001 2.001 0 0 1-2 0L41.02 411.393a2 2 0 0 1-1-1.732V164.76a2 2 0 0 1 1-1.732L253 40.578z",
    stroke: "#6C84F8",
    strokeWidth: 12,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0.021,
    y: 0.31,
    width: 507.959,
    height: 573.802,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17,
    result: "effect1_foregroundBlur_1109_3117"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 25.041,
    y: 14.31,
    width: 479.959,
    height: 545.802,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_1109_3117"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 3,
    y: 14.31,
    width: 479.959,
    height: 545.802,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_1109_3117"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagonBlueMin);
export default __webpack_public_path__ + "static/media/hexagon-blue-min.3797a8c4c180fb017a859afbff5717d9.svg";
export { ForwardRef as ReactComponent };